import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { SmUiComponent } from '../sm-ui/sm-ui.component';
import { ControlContainer, FormGroupDirective,  NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'sm-select',
    templateUrl: './sm-select.component.html',
    styleUrls: ['./sm-select.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SmSelectComponent),
            multi: true
        }
    ]
})
export class SmSelectComponent extends SmUiComponent implements OnInit {
    @Input() options;
    bindValue: string = '';
    @Output() selected = new EventEmitter<any>();
    @Output() filteredState = new EventEmitter<any>();
    isDisable: boolean = true;
    @Input() placeHolder: string = null;

    override ngOnInit(): void {
        super.ngOnInit();
        this.props.originalOptions =this.options;
        this.bindValue = this.props.bindValue;
      
        
        // if (this.props.readOnly) {
        //     this.formcontrol.disable();
        //   }

    }

    onMaterialGroupChange(event): any {
        this.selected.emit(this.formcontrol.value);
        return event;
    }

    onSelectAll(select): void {
        const selected = this.options.map(item => item.id);
        this.formcontrol.patchValue(selected);
        select.close();
    }

    filterEmitter(event): void {
        this.props.filterOptions.forEach((filter, index) => {
            if (filter.id === event.target.id) {
                filter.state = event.target.checked;
                
            }
        });
        this.filteredState.emit(this.props.filterOptions);
    }
}
